import { useEffect, useState } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { supabase } from "@/integrations/supabase/client";

/**
 * Returns the count of unseen market_alerts for the current user.
 * Light polling (every 60s) — no realtime subscription overhead.
 */
export function useUnseenAlertsCount(): number {
  const { user } = useAuth();
  const [count, setCount] = useState(0);

  useEffect(() => {
    if (!user) { setCount(0); return; }
    let cancelled = false;
    const fetchCount = async () => {
      const { count: c } = await supabase
        .from("market_alerts")
        .select("id", { count: "exact", head: true })
        .eq("user_id", user.id)
        .is("seen_at", null);
      if (!cancelled) setCount(c ?? 0);
    };
    void fetchCount();
    const t = setInterval(fetchCount, 60_000);
    return () => { cancelled = true; clearInterval(t); };
  }, [user]);

  return count;
}
